import React from "react";
import { Button } from "antd";
import { Link } from "react-router-dom"
import { connect } from "react-redux";
import icons from "Common/Icons";
import ListComponent from "Components/ListComponent";
import { PHILABEL } from "../../Common/constant"
import { CONSTANTS } from "utils/constant";

class PatientDetailPhi extends React.Component {
  _baseClassName = "patient-detail-phi-container";
  constructor(props) {
    super(props);
    this.state = {
      phi_percentage: this.props.data.percentage
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.data !== prevState.data || nextProps.phi_percentage !== prevState) {
      let obj = nextProps.data;
      let percentage = nextProps.data?.percentage
      let excludeKeys = ["percentage","is_blood_test","is_evolution_of_illness"]
      nextProps?.gender == "male" ? excludeKeys.push("is_menstruation_detail") : '';
      nextProps?.usertype == "adolescent" ? excludeKeys.push("is_occupational_detail", "is_sexual_health", "is_energy_level_and_exercise_routine","is_constitutional_analysis") : '';
      let finalArray = Object.keys(obj || {}).reduce((acc, key) => {
        if (excludeKeys.indexOf(key) == -1) acc.push({ label: key, value: obj[key] });
        return acc;
      }, [])
      return { data: finalArray, phi_percentage: percentage };
    } else return null;
  }
  render() {
    return (
      <div className={this._baseClassName}>
        <div className="patient-detail-assessment-main">
          <div className="header-container">
            <img src={icons.phi_db}></img>
            <div className="header-name">{CONSTANTS.HEALTH_INFORMATION}</div>
          </div>
          <div className="main-content">
            <div className="top-content">
              {/* <div>{CONSTANTS.HEALTH_INFORMATION}</div> */}
              <div className="health-profile-completed"> {this.state.phi_percentage}{CONSTANTS.COMPLETED}</div>
            </div>
            <div className="bottom-content">
              <div className="bottom-content-header">
                <div className="left-content">
                  <div>{CONSTANTS.SECTION_OF_HI_SUMMARY}</div>
                  {/* <div>Summary of your present and past health records</div> */}
                </div>
                <div className="right-content">
                  <Link to={{
                    pathname: "health-profile",
                    state: {
                             patientName : this.props?.patientName || "",
                             patientUID : this.props?.patientUID || "",
                   },
                  }}> <Button icon={<img src={icons.arrow_icon} />}>
                    {CONSTANTS.VIEW_SUMMARY}
                  </Button>
                  </Link>
                </div>
              </div>
              <div className="phi-lists">
                <ListComponent
                  data={this.state.data || []}
                  showMore={{ initialLength: 6 }}
                  render={obj => {
                    if (obj.label.includes("phi_complete")) return (<></>)
                    return (<div className="phi-form-name">
                      <div><Link className="link" to={{ pathname: "/doctor/health-profile", state: { data: obj.label.replace("is_", "") ,patientName : this.props?.patientName || "", patientUID : this.props?.patientUID || "", } }} > {PHILABEL[obj.label.replace("is_", "")] || ''}</Link></div>
                      {obj.value ? <Link className="phi-form-icon" to={{ pathname: "/doctor/health-profile", state: { data: obj.label.replace("is_", "") ,patientName : this.props?.patientName || "", patientUID : this.props?.patientUID || "",} }} >  <span>&#10003;</span> </Link> : <span><img src={icons.tick_icon} /></span>}
                    </div>)
                  }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    gender: state.patientDetailReducer.gender,
    usertype: state.patientDetailReducer.usertype,
  }
}


export default connect(mapStateToProps)(PatientDetailPhi);